module.exports = __webpack_public_path__ + "files/648864f559fa1867196750aeea4f19af.png";